import "@/index.css";
import "@fontsource/barlow-condensed/400.css";
import "@fontsource/barlow-condensed/600.css";
import "@fontsource/barlow-condensed/700.css";
import "@fontsource/barlow-condensed/900.css";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/700.css";

import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Portfolio from "@/pages/Portfolio";
import Markets from "@/pages/Markets";
import Alerts from "@/pages/Alerts";
import Scanner from "@/pages/Scanner";
import HiddenGems from "@/pages/HiddenGems";
import Earnings from "@/pages/Earnings";
import FutureIsHere from "@/pages/FutureIsHere";
import Settings from "@/pages/Settings";
import SPSignals from "@/pages/SPSignals";
import ExplosiveMovers from "@/pages/ExplosiveMovers";
import SmartMoney from "@/pages/SmartMoney";
import AVBot from "@/pages/AVBot";
import SohelPick from "@/pages/SohelPick";
import News from "@/pages/News";
import EmergentPromise from "@/pages/EmergentPromise";
import SohelAnalysis from "@/pages/SohelAnalysis";
import PaperPortfolio from "@/pages/PaperPortfolio";
import SohelAgenticAI from "@/pages/SohelAgenticAI";
import BackendStatusBanner from "@/components/BackendStatusBanner";
import ExperimentalWork from "@/pages/ExperimentalWork";
import TVDisplay from "@/pages/TVDisplay";
import FalconViewAdmin from "@/pages/FalconViewAdmin";
import FalconAdmin from "@/pages/FalconAdmin";

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id - handle auth callback synchronously
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/tv" element={
        <ProtectedRoute>
          <TVDisplay />
        </ProtectedRoute>
      } />
      <Route path="/*" element={
        <ProtectedRoute>
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/markets" element={<Markets />} />
              <Route path="/sohel-pick" element={<SohelPick />} />
              <Route path="/sp-signals" element={<SPSignals />} />
              <Route path="/explosive-movers" element={<ExplosiveMovers />} />
              <Route path="/smart-money" element={<SmartMoney />} />
              <Route path="/future" element={<FutureIsHere />} />
              <Route path="/av-bot" element={<AVBot />} />
              <Route path="/scanner" element={<Scanner />} />
              <Route path="/hidden-gems" element={<HiddenGems />} />
              <Route path="/earnings" element={<Earnings />} />
              <Route path="/news" element={<News />} />
              <Route path="/emergent-promise" element={<EmergentPromise />} />
              <Route path="/sohel-analysis" element={<SohelAnalysis />} />
              <Route path="/paper-portfolio" element={<PaperPortfolio />} />
              <Route path="/sohel-agentic-ai" element={<SohelAgenticAI />} />
              <Route path="/experimental" element={<ExperimentalWork />} />
              <Route path="/falcon-view" element={<FalconViewAdmin />} />
              <Route path="/falcon-admin" element={<FalconAdmin />} />
              <Route path="/alerts" element={<Alerts />} />
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </Layout>
        </ProtectedRoute>
      } />
    </Routes>
  );
}

function App() {
  return (
    <div className="min-h-screen bg-background">
      <div className="noise-overlay" />
      <AuthProvider>
        <BrowserRouter>
          <BackendStatusBanner />
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
